import { css } from "@emotion/react"
import { useMemo } from "react"

type Props = {
  size: number
  axis?: "vertical" | "horizontal"
}

const Spacer = ({ size, axis }: Props) => {
  const width = axis === "vertical" ? 1 : size
  const height = axis === "horizontal" ? 1 : size

  const style = useMemo(() => {
    return css`
      display: block;
      width: ${width}px;
      min-width: ${width}px;
      height: ${height}px;
      min-height: ${height}px;
    `
  }, [height, width])

  return <span css={style} />
}

export default Spacer
